import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export interface CounterpartEmail {
  email: string;
  designatedOperator: string;
  module: string;
}

export interface CounterpartEmailsResponse {
  emails: CounterpartEmail[];
}

interface UseCounterpartEmailsParams {
  module: string;
  inboundOperator: string;
  outboundOperator: string;
  enabled?: boolean;
}

/**
 * Hook to fetch counterpart emails
 * 
 * @param params Module name, inbound operator, and outbound operator
 * @returns Query result with counterpart emails
 */
export const useCounterpartEmails = ({
  module,
  inboundOperator,
  outboundOperator,
  enabled = true,
}: UseCounterpartEmailsParams) => {
  return useQuery<CounterpartEmailsResponse>({
    queryKey: ['counterpartEmails', module, inboundOperator, outboundOperator],
    queryFn: async () => {
      const params = new URLSearchParams();
      params.append('module', module);
      params.append('inboundOperator', inboundOperator);
      params.append('outboundOperator', outboundOperator);

      const response = await axios.get(`/user/counterpart-emails?${params.toString()}`);
      return response.data;
    },
    enabled: enabled && !!module && !!inboundOperator && !!outboundOperator,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    refetchOnWindowFocus: false,
  });
};

